var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.toggleItem }, [
    _c(
      "div",
      {
        class: [
          _vm.$style.toggleItemTitleBlock,
          _vm.isTabletLandscapeUp
            ? _vm.$style.defaultText
            : _vm.$style.smallText,
        ],
        on: { click: _vm.toggleDetails },
      },
      [
        _c("p", { class: _vm.$style.toggleItemTitle }, [
          _vm._v(" " + _vm._s(_vm.title) + " "),
        ]),
        _c(
          "p",
          { class: _vm.$style.toggleItemIcon },
          [_c("IconArrowDown", { attrs: { width: "27" } })],
          1
        ),
      ]
    ),
    _vm.showDetails
      ? _c(
          "div",
          {
            class: [
              _vm.$style.toggleItemContentBlock,
              _vm.isTabletLandscapeUp
                ? _vm.$style.defaultText
                : _vm.$style.smallText,
            ],
          },
          [_c("p", { domProps: { innerHTML: _vm._s(_vm.content) } })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }